import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { EnvironmentConfig, ENV_CONFIG } from '@core/environment-config.interface';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '@shared/models/language';
import { Locale } from '@shared/models/locale';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonService } from './common.service';
import { DataService } from './data.service';
import { MaintenanceService } from './maintenance.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  public activeLanguageSubject: BehaviorSubject<Language>;
  public activeLanguage: Observable<Language>;
  public defaultLanguage: Language;
  public languages: Language[];

  constructor(
    private userService: UserService,
    private http: HttpClient,
    private commonService: CommonService,
    private translateService: TranslateService,
    private maintenanceService: MaintenanceService,
    private dataService: DataService,
    private titleService: Title,
  ) {

    this.languages = this.dataService.languages;

    this.userService.getLoggedUser().subscribe(user => {
      this.defaultLanguage = this.languages.find(x => x.code.toLowerCase() === user.locale) || this.languages[0];

      this.translateService.addLangs(this.languages.map(x => { return x.code.toLowerCase() }));
      this.translateService.setDefaultLang(this.defaultLanguage.code.toLowerCase());
      this.translateService.get('common.title').subscribe((res: string) => { this.titleService.setTitle(res); });

      // ?? remove ??
      this.activeLanguageSubject = new BehaviorSubject(this.defaultLanguage);
      this.activeLanguage = this.activeLanguageSubject.asObservable();
    });

    // refactor!!!
    this.maintenanceService.maintenanceMode$.subscribe( isMaintenance => {
      if(isMaintenance){

        this.defaultLanguage = this.languages.find(x => x.code.toLowerCase() === this.maintenanceService.maintenanceLanguage) || this.languages[0];

        this.translateService.addLangs(this.languages.map(x => { return x.code.toLowerCase() }));
        this.translateService.setDefaultLang(this.defaultLanguage.code.toLowerCase());
        this.translateService.get('common.title').subscribe((res: string) => { this.titleService.setTitle(res); });

        // ?? remove ??
        this.activeLanguageSubject = new BehaviorSubject(this.defaultLanguage);
        this.activeLanguage = this.activeLanguageSubject.asObservable();
      }
    });

  }

  changeLanguage(language: string) {

    language = language.toLowerCase();
    if (!this.translateService.getLangs().includes(language)) {
      language = (this.defaultLanguage.code).toLowerCase();
    }

    this.userService.getLoggedUser().subscribe(user => {

      this.setLocale(language).subscribe((locale: Locale) => {
        user.locale = locale.code;
        this.translateService.use(locale.code);
        this.translateService.get('common.title').subscribe((res: string) => { this.titleService.setTitle(res); });

        this.activeLanguageSubject.next(this.languages.find(x => x.code.toLowerCase() === locale.code));
      });

    });

  }

  private setLocale(locale: string) {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next({ code: locale } as Locale));
    }

    return this.http.post<Locale>(this.commonService.getServiceUrl('locale'), { locale: locale });
  }

}
